import { AppColors } from "@/styles/colors";
import { Button, CloseButton, Dialog, Flex, Portal, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { LightMode } from "../ui/color-mode";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
  open: boolean;
  setOpen: (flag: boolean) => void;
  pedidoLabel?: string;
  motivo?: string | null;
  fecha?: string | null;
  usuario?: string | null;
}

export const SuppliesOrderCancelMotiveModal = ({
  open,
  setOpen,
  pedidoLabel,
  motivo,
  fecha,
  usuario,
}: Props) => {
  return (
    <Dialog.Root
      placement="center"
      lazyMount
      open={open}
      onOpenChange={(e) => setOpen(e.open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <LightMode>
            <Dialog.Content>
              <Dialog.Header paddingY="16px" paddingLeft="24px">
                <Dialog.Title fontWeight={600} color={AppColors.GRAY_TEXT} fontSize="18px">
                  Motivo de cancelación{pedidoLabel ? ` - ${pedidoLabel}` : ""}
                </Dialog.Title>
              </Dialog.Header>
              <Dialog.Body paddingX="24px" paddingY="8px" width="100%">
                <Flex
                  flexDir="column"
                  paddingX="24px"
                  borderLeft={`4px solid ${AppColors.WHITE_BORDER_1}`}
                >
                  <Text fontWeight={400}>{motivo ?? "-"}</Text>
                  <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
                    {fecha
                      ? dayjs
                          .utc(fecha)
                          .tz("America/Argentina/Buenos_Aires")
                          .format("DD/MM/YYYY - HH:mm")
                      : "-"}{" "}
                    - {usuario ?? "-"}
                  </Text>
                </Flex>
              </Dialog.Body>
              <Dialog.Footer paddingY="16px" paddingX="24px">
                <Dialog.ActionTrigger asChild>
                  <Button variant="outline" paddingX="16px" fontWeight={600}>
                    Cerrar
                  </Button>
                </Dialog.ActionTrigger>
              </Dialog.Footer>
              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Content>
          </LightMode>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
